<template>
  <div class="d-flex align-items-center">
    <strong>Loading...</strong>
    <b-spinner class="ml-auto"></b-spinner>
  </div>
</template>

<script>
export default {
  name: 'Spinner',
}
</script>
